{
	"translateEventStatus": {
		"canceled": "Annulé",
		"created": "Créé",
		"finished": "Terminé",
		"running": "En cours"
	},
	"translatePaymentMethod": {
		"anticipated": "Anticipé",
		"app": "App",
		"appPrePayment": "Paiement via app",
		"bonus": "Bonus",
		"cash": "Espèces",
		"creditCard": "Carte de crédit",
		"dashboard": "Tableau de bord",
		"debitCard": "Carte de débit",
		"pix": "Pix",
		"postEvent": "Post event",
		"rappi": "Rappi",
		"voucher": "Voucher",
		"zigPosCredit": "Zig post crédit",
		"zigPosDebit": "Zig post débit",
		"integratedFoodVoucher": "Ticket Restaurant"
	}
}
